import Plotly from "plotly.js-dist-min";

export function resizePlot() {
    const r = document.querySelector(":root");
    let plotContainer = document.querySelector(".graph-container");
    if (plotContainer) {
        let plotWidth = plotContainer.clientWidth / 700;
        let plotHeight = plotContainer.clientHeight / 280;
        r.style.setProperty("--graph-width", plotWidth);
        r.style.setProperty("--graph-height", plotHeight);
        Plotly.update(document.querySelector(".js-plotly-plot"));
    }
}
